export const REPORT_DURATION_REALTIME: number = 0
export const REPORT_DURATION_DAY_CURRENT: number = 10
export const REPORT_DURATION_DAY_PREVIOUS: number = 11
export const REPORT_DURATION_WEEK_CURRENT: number = 20
export const REPORT_DURATION_WEEK_PREVIOUS: number = 21
export const REPORT_DURATION_MONTH_CURRENT: number = 30
export const REPORT_DURATION_MONTH_PREVIOUS: number = 31
export const REPORT_DURATION_LAST_X_DAYS: number = 50
export const REPORT_DURATION_CUSTOM_DATETIME: number = 100
